import { motion } from 'framer-motion';
import { DollarSign, TrendingUp, PiggyBank, Coins } from 'lucide-react';

const icons = [DollarSign, TrendingUp, PiggyBank, Coins];

export default function FloatingMoneyIcons() {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
      {[...Array(12)].map((_, i) => {
        const Icon = icons[i % icons.length];
        const size = Math.random() * 30 + 20;
        const duration = Math.random() * 20 + 20;
        const delay = Math.random() * 10;
        
        return (
          <motion.div
            key={i}
            className="absolute"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
            }}
            initial={{ opacity: 0, scale: 0 }}
            animate={{
              opacity: [0, 0.15, 0],
              scale: [0.5, 1, 0.5],
              rotate: [0, 360],
              y: [-50, 50],
            }}
            transition={{
              duration,
              repeat: Infinity,
              ease: 'easeInOut',
              delay,
            }}
          >
            <Icon
              size={size}
              className="text-amber-500"
              style={{
                filter: 'drop-shadow(0 0 10px rgba(245, 158, 11, 0.3))',
              }}
            />
          </motion.div>
        );
      })}
    </div>
  );
}
